import _ from 'lodash'
import ProductPicker from './ProductPicker'
import { AppDispatch, RootState } from '@/stores'
import { useDispatch, useSelector } from 'react-redux'
import { createComponentAction } from '@/stores/active-design'

type ProductPickerPropTypes = {
  isOpen: boolean
  onClose: () => void
  productType?: string
  parentId?: string
}

const AddProductPicker = ({ isOpen, onClose, productType, parentId }: ProductPickerPropTypes) => {
  const dispatch = useDispatch<AppDispatch>()
  const { design } = useSelector((state: RootState) => state.activeDesign)

  // Get the cast-in channel and slab as fallbacks for if the parent ID is not provided
  // e.g. when adding a product from the top bar instead of from a selected component
  const castInChannel = design?.components.find((component) => {
    return Object.prototype.hasOwnProperty.call(component, 'cast_in_anchor_channel')
  })

  const slab = design?.components.find((component) => {
    return component.type === 'concrete_slab'
  })

  return (
    <ProductPicker
      isOpen={isOpen}
      onClose={onClose}
      productType={productType ?? (castInChannel ? 't_bolt' : 'cast_in_anchor_channel')}
      parentId={parentId ?? castInChannel?.id ?? slab?.id}
      onConfirm={(productVariant) => {
        switch (productVariant.product_type) {
          case 'cast_in_anchor_channel':
            dispatch(createComponentAction({
              details: {
                parent_id: parentId ? parentId : slab?.id,
                type: 'product_variant',
                product_variant_id: productVariant.id,
                position: {
                  x: 0,
                  y: 0,
                  z: 0,
                },
                cast_in_anchor_channel: {
                  length: parseInt(productVariant.cast_in_anchor_channel!.lengths[0].length),
                },
              },
            }))
            break
          case 't_bolt':
            dispatch(createComponentAction({
              details: {
                parent_id: parentId ? parentId : castInChannel?.id,
                type: 'product_variant',
                product_variant_id: productVariant.id,
                position: {
                  x: 0,
                  y: 0,
                  z: 0,
                },
                t_bolt: {
                  shear_force: 0,
                  tension_force: 0,
                  stand_off_distance: 0,
                  diameter: productVariant.t_bolt!.diameters[0].name,
                  length: productVariant.t_bolt!.lengths[0].toString(),
                },
              },
            }))
            break
        }

        onClose()
      }}
    />
  )
}

export default AddProductPicker
